<mat-toolbar color="primary">
    <span>Dossier</span>
    <span class="toolbar-spacer"></span>
    <button mat-icon-button class="example-icon favorite-icon" aria-label="Example icon-button with heart icon">
        <mat-icon>search</mat-icon>
    </button>    
</mat-toolbar>
<app-record-tree [location]="'panel'"></app-record-tree>
<!-- <mat-drawer-container class="drawer-container" autosize>
    <mat-drawer #drawer opened class="drawer-sidenav" mode="side">
    </mat-drawer>
    <div class="drawer-sidenav-content">
        Content
    </div>
</mat-drawer-container>   -->